package cmp_tuner.composeapp.generated.resources

import kotlin.ByteArray
import kotlin.OptIn
import kotlin.String
import org.jetbrains.compose.resources.ExperimentalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.readResourceBytes

@OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)
@ExperimentalResourceApi
internal object Res {
  /**
   * Reads the content of the resource file at the specified path and returns it as a byte array.
   *
   * Example: `val bytes = Res.readBytes("files/key.bin")`
   *
   * @param path The path of the file to read in the compose resource's directory.
   * @return The content of the file as a byte array.
   */
  public suspend fun readBytes(path: String): ByteArray = readResourceBytes(path)

  public object string {
    public val app_name: StringResource = StringResource(
          "string:app_name",
          "app_name",
          setOf(
            ResourceItem(
              setOf(),
              "values/strings.xml"
            ),
          )
        )

    public val classic_guitar: StringResource = StringResource(
          "string:classic_guitar",
          "classic_guitar",
          setOf(
            ResourceItem(
              setOf(),
              "values/strings.xml"
            ),
          )
        )

    public val high: StringResource = StringResource(
          "string:high",
          "high",
          setOf(
            ResourceItem(
              setOf(),
              "values/strings.xml"
            ),
          )
        )

    public val low: StringResource = StringResource(
          "string:low",
          "low",
          setOf(
            ResourceItem(
              setOf(),
              "values/strings.xml"
            ),
          )
        )

    public val match: StringResource = StringResource(
          "string:match",
          "match",
          setOf(
            ResourceItem(
              setOf(),
              "values/strings.xml"
            ),
          )
        )
  }
}
